export const TYPE = {
  LOGIN: 'login',
  PASS: 'PASSWORD'
}